// API Configuration for different environments
const API_BASE_URL = 'https://djhqa2y0tc.execute-api.us-east-1.amazonaws.com/dev';

// Logging service — this site has no backend of its own for logging, so it
// reuses the fs-assistant FastAPI service's DynamoDB-backed log endpoints
// (see fs-assistant/backend/src/fastapi/routes/{page_access_log,app_log}.py)
// rather than standing up a duplicate one here.
const LOG_API_BASE_URL = process.env.REACT_APP_LOG_API_URL ||
  'https://vo7dhmgn2y6srtxdyi524oxcte0wrpmq.lambda-url.us-east-1.on.aws';
const LOG_ACCESS_ENDPOINT = `${LOG_API_BASE_URL}/log-access`;
const APP_LOG_ENDPOINT = `${LOG_API_BASE_URL}/app-log`;
const APP_LOG_SOURCE = 'construction-website-app-logs';
// Tags every entry this site writes to the shared Logging table. Without it,
// the backend's item.setdefault("Application", ...) would default our rows
// to "fs-assistant" (its own LOGGING_APPLICATION), attributing them to the
// wrong app.
const APPLICATION_NAME = 'construction-website';

export {
  API_BASE_URL,
  LOG_API_BASE_URL,
  LOG_ACCESS_ENDPOINT,
  APP_LOG_ENDPOINT,
  APP_LOG_SOURCE,
  APPLICATION_NAME,
};